import React, { useState, useEffect } from 'react';
import AuthService from '../../services/Auth.service';
import './header.css';
import { Fade as Hamburger } from 'hamburger-react';
import { useHistory } from 'react-router-dom';
import { NumberFormat as numberUtils } from '../../utilities/NumberFormat';
import { LogOut } from 'lucide-react';
import { usePage } from '../../context/PageContext';

import { PanelLeft } from 'lucide-react';

function Header({ sidebarToggle, toggle }) {
   const [showDropdown, setShowDropdown] = useState(false);
   const [user, setUser] = React.useState();
   const { pageTitle } = usePage();
   const history = useHistory();

   useEffect(() => {
      setUser(AuthService.getCurrentUser() || {});
   }, []);

   const username = user?.name || "Guest";
   const userInitial = username.charAt(0).toUpperCase();

   const logout = () => {
      AuthService.logout();
      history.push('/');
      numberUtils.tabTitle('Login');
   };

   useEffect(() => {
      const handleClickOutside = (event) => {
         if (showDropdown && !event.target.closest('.user-profile')) {
            setShowDropdown(false);
         }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
         document.removeEventListener('mousedown', handleClickOutside);
      };
   }, [showDropdown]);

   const headerStyle = {
      position: 'fixed',
      top: 0,
      right: 0,
      padding:"5px",
      left: sidebarToggle ? '75px' : '260px',
      width: sidebarToggle ? 'calc(100% - 70px)' : 'calc(100% - 260px)',
      transition: 'left 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      zIndex: 1000,
   };

   return (
      <header className='header' style={headerStyle}>
         <div className='header-container'>
            <div className='header-left'>
               <div className='hamber-icon'>
                  <div className="header-mobile-header-group">
                     <button onClick={toggle} className="header-toggle-mobile-btn" aria-label="Toggle Navigation">
                        <PanelLeft size={18} />
                     </button>
                     <img src="/assets/images/logo.svg" height={38} alt="Logo" className="header-mobile-logo" />
                  </div>
                  <ul className='navbar-navbox legacy-hamburger-wrapper'>
                     <div className='nav-link' onClick={toggle} style={{ cursor: 'pointer' }}>
                        <Hamburger toggled={!sidebarToggle} />
                     </div>
                  </ul>
               </div>
               <h1 className='page-title'>{pageTitle}</h1>
            </div>

            <div className='header-right'>
               <div className='user-profile' onClick={() => setShowDropdown(!showDropdown)}>
                  <div className='user-details'>
                     <div className='user-name'>{username}</div>
                     <div className='role-title'>{user?.access}</div>
                  </div>
                  <div className='user-avatar'>
                     <img
                        src="/assets/images/user-img.png"
                        alt="User"
                        style={{ width: "40px", height: "35px", borderRadius: "50%" }}
                     />
                  </div>
                  
                  
                  {showDropdown && (
                     <div className='profile-dropdown'>
                        <div className='dropdown-item' onClick={logout}>
                           <LogOut size={16} className="dropdown-icon" />
                           Logout
                        </div>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </header>
   );
}

export default Header;